import { Linking, Platform } from 'react-native';

/** A shared point, never a request for the viewer's current location. */
export function validMapPoint(latitude: unknown, longitude: unknown): boolean {
  return typeof latitude === 'number' && Number.isFinite(latitude) && Math.abs(latitude) <= 90
    && typeof longitude === 'number' && Number.isFinite(longitude) && Math.abs(longitude) <= 180;
}

export function mapsUrl(latitude: number, longitude: number): string {
  if (!validMapPoint(latitude, longitude)) throw new Error('Invalid map point');
  const point = `${latitude},${longitude}`;
  if (Platform.OS === 'ios') return `https://maps.apple.com/?ll=${point}&q=${point}`;
  if (Platform.OS === 'android') return `geo:${point}?q=${point}`;
  return `https://www.google.com/maps/search/?api=1&query=${point}`;
}

/** Called only on an explicit tap. A rejected native handoff remains an error. */
export async function openLocationMap(latitude: number, longitude: number): Promise<void> {
  await Linking.openURL(mapsUrl(latitude, longitude));
}
